import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'general-layout',
  templateUrl: './general-layout.component.html',
  styleUrls: ['./general-layout.component.scss']
})
export class GeneralLayoutComponent implements OnInit, OnDestroy {
  minifySidebar = false;
  oldLayout = false;

  routerEventsSubscription: Subscription;
  routeSubscription: Subscription;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.routeSubscription = this.route.url.subscribe(() => {
      // initial loading
      this.updateLayoutState();
    });

    this.routerEventsSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // on navigation
        this.updateLayoutState();
      }
    });
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
    this.routerEventsSubscription?.unsubscribe();
  }

  updateLayoutState() {
    const { data } = this.route.snapshot.firstChild;
    this.minifySidebar = data.minifySidebar || false;
    this.oldLayout = data.oldLayout || false;
  }
}
